// src/modules/app-views/_apps/appmulti/orders/pages/Init/components/tableColumns/orderDateColumn.js
// *******************************************************************************
// ORDER DATE COLUMN
// *******************************************************************************
import dayjs from 'dayjs';
import translateX from 'utils/translateX';

const orderDateColumn = buildColumnProps => ({
  key: 'order_date',
  title: translateX('order_date'),
  dataIndex: ['_metadata', 'audit', 'createdAt'],
  ...buildColumnProps('_metadata.audit.createdAt', { sort: true }),
  align: 'center',
  width: 160,
  render: value => (value ? dayjs(value).format('L LT') : '—'),
});

export default orderDateColumn;
